<template>
  <div class="w1200" style="margin-top: 15px">
    <div class="bg">
      <span style="float: left; font-size: 16px; line-height: 32px">上传资源</span>
      <el-button
        type="primary"
        size="small"
        style="float: right"
        @click="$router.push({ name: 'resource' })"
        >返回</el-button
      >
    </div>
    <div class="bg">
      <upload1
        class="upload-card"
        drag
        :size="1024 * 1024 * 3"
        @input="
          (e) => {
            data = data.concat(e);
          }
        "
        :url="url"
        :auth="auth"
        ><el-button type="primary">上传文件</el-button>
        <span>点击或将文件拖拽到这里上传</span>
        <span>支持拓展名：.rar .zip .doc .docx .pdf .jpg...</span></upload1
      >
      <div class="upload">
        <div class="hd">
          <h4>
            已上传资料<em>{{ data.length }}份</em>
          </h4>
          <span></span>
        </div>
        <div class="bd">
          <ul>
            <li v-for="(d, i) in data" :key="'upload' + i">
              <span class="sn">{{ i + 1 }}</span
              ><em>*</em><span class="title">标题</span
              ><el-input
                placeholder="请输入内容"
                v-model="d.fileName"
                style="width: 450px"
                size="small"
              >
                <svg class="icon" slot="prefix" aria-hidden="true">
                  <use :xlink:href="'#icontbx' + d.fileType"></use>
                </svg>
              </el-input>
              <span class="suffix">{{ d.type }}</span>
              <div class="page">
                <template v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3">
                  页数：<el-input
                    v-model="d.filePage"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                </template>
                <!-- <div>时长：</div> -->
              </div>
              <span class="title">类别</span>
              <el-select
                v-model="d.resourceTypeId"
                placeholder="请选择"
                size="small"
                style="width: 120px"
              >
                <el-option
                  v-for="item in categoryData"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <el-checkbox v-model="d.isShareSystem" style="margin: 0 25px"
                >共享</el-checkbox
              >
              <el-button type="text" @click="del(d.fileUrl, i)">删除</el-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bg">
      <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
        <el-form-item label="学段学科:">
          <el-popover placement="top" width="200" trigger="hover">
            <el-tabs v-model="activeName1" class="popoverSection">
              <el-tab-pane
                :label="section.label"
                v-for="(section, i) in sectionData"
                :key="'section' + i"
                :name="section.id"
                ><ul v-if="section.children">
                  <li
                    v-for="(subject, j) in section.children"
                    :key="'subject_' + i + '_' + j"
                    @click="selApd(section, subject)"
                  >
                    <span>{{ subject.label }}</span>
                  </li>
                </ul></el-tab-pane
              >
            </el-tabs>
            <el-button slot="reference"
              >{{ apd }} <i class="el-icon-arrow-down"></i
            ></el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="资源目录:">
          <el-input
            :value="selData"
            placeholder="请选择"
            @focus="dialogVisible = true"
            style="width: 500px"
          ></el-input>
        </el-form-item>
        <el-form-item label="年级:">
          <span style="color: #606266">{{
            form.gradeId ? gradeData.filter((el) => el.node == form.gradeId)[0].text : ""
          }}</span>

          <!-- <el-select v-model="form.gradeId" placeholder="请选择">
            <el-option
              v-for="item in gradeData"
              :key="item.node"
              :label="item.text"
              :value="item.node"
            >
            </el-option> </el-select> -->
        </el-form-item>
      </el-form>
    </div>
    <el-button
      type="primary"
      style="margin: 0 auto 50px; width: 150px; clear: both; display: block"
      @click="save()"
      >确认上传</el-button
    >
    <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="1100px">
      <div
        class="tree"
        v-if="tree.filter((el) => el.id == sectionId)[0] && subjectId"
        :style="'width:' + (clickData.length + 1) * 180 + 'px;margin: 0 auto;'"
      > -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :width="
        clickData.length * 180 +
        (clickData.length > 1
          ? clickData[clickData.length - 1].children.length > 0
            ? 180
            : 0
          : 180) +
        30 +
        'px'
      "
    >
      <div
        class="tree"
        v-if="tree.filter((el) => el.id == sectionId)[0] && subjectId"
        style="margin-left: 5px"
      >
        <div>
          <tree
            v-model="clickData"
            :num="0"
            :data="
              tree
                .filter((el) => el.id == sectionId)[0]
                .children.filter((el) => el.id == subjectId)[0].children
            "
          ></tree>
        </div>
      </div>
      <!-- <span v-else>请选择学段学科</span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            dialogVisible = false;
            selData = clickData.map((el) => el.label).join(' > ');
            form.gradeId = clickData[clickData.length - 1].gradeId;
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import upload from "../../mixins/upload";
import upload1 from "../../common/upload1";
import tree from "./tree";
export default {
  data() {
    return {
      url: "",
      auth: {},
      data: [],
      categoryData: [],
      gradeData: [],
      relationData: [],
      defaultProps: {
        label: "label",
        children: "children",
        isLeaf: "childCount",
      },
      form: { gradeId: "" },
      activeName1: 1,
      apd: "",
      sectionId: "",
      subjectId: "",
      gradeId: "",
      treeShow: false,
      dialogVisible: false,
      selData: "",
      clickData: [],
      activeName1: "",
      filetype: [
        { name: "doc", value: 1 },
        { name: "docx", value: 1 },
        { name: "ppt", value: 2 },
        { name: "pptx", value: 2 },
        { name: "pdf", value: 3 },
        { name: "png", value: 4 },
        { name: "jpg", value: 4 },
        { name: "jpeg", value: 4 },
        { name: "gif", value: 4 },
        { name: "bmp", value: 4 },
        { name: "mp4", value: 5 },
      ],
      tree: [],
      treeData: {},
      treeData1: {},
      treeData2: {},
      treeData3: {},
      treeData4: {},
      treeData5: {},
      treeData6: {},
    };
  },
  // mixins: [upload],
  components: { upload1, tree },
  computed: {
    ...mapState(["userModule"]),
  },
  props: {
    sectionData: { type: Array },
    breadcrumb: { type: Array },
    activeName: { type: String, default: "0" },
    breadcrumbData: { type: Object },
    init1: { type: Number },
  },
  mounted() {
    this.url = window.sessionStorage.getItem("uploadUrl");
    this.auth = {
      clientId: window.sessionStorage.getItem("clientId"),
      token: window.sessionStorage.getItem("token"),
    };
  },
  watch: {
    init1: {
      handler(n, o) {
        if (n != 0) {
          this.init();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    del(url, i) {
      let a = url.split("/")[1];
      axios
        .post(
          window.sessionStorage.getItem("uploadUrl") + "/" + a + "/deletefile",
          {
            Path: url,
          },
          {
            headers: {
              "Content-Type": "application/json",
              clientId: window.sessionStorage.getItem("clientId"),
              token: window.sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.data.suc) {
            this.data.splice(i, 1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    init() {
      // this.breadcrumb1 = this.breadcrumb;
      this.activeName1 = this.activeName;
      this.apd = this.breadcrumb[1];
      this.sectionId = this.breadcrumbData.sectionId;
      this.subjectId = this.breadcrumbData.subjectId;
      this.treeShow = true;
      this.getData();
      this.getGrade();
      this.getTree();
    },
    getGrade() {
      this.$ajax
        .post("/common/catalog/load/grade", {
          sectionId: this.sectionId,
          subjectId: this.subjectId,
        })
        .then((res) => {
          this.gradeData = res;
        });
    },
    getTree() {
      this.$ajax.post("/common/catalog/load/catalog/tree", {}).then((res) => {
        this.tree = res;
      });
    },
    save() {
      if (this.data.length == 0) {
        this.$message.error("请上传资源");
        return false;
      }
      if (this.clickData.length == 0) {
        this.$message.error("请上选择资源目录");
        return false;
      }
      if (!this.form.gradeId) {
        this.$message.error("请上选择年级");
        return false;
      }
      let a = this.data.filter((el) => {
        if (el.fileType == 1 || el.fileType == 2 || el.fileType == 3) {
          if (el.filePage == "") {
            return true;
          }
        }
      });
      let c = this.data.filter((el) => el.name == "");
      if (c.length > 0) {
        this.$message.error("请为相应资源填上名称");
        return false;
      }
      if (a.length > 0) {
        this.$message.error("请为相应资源填上页数");
        return false;
      }
      let b = this.data.filter((el) => el.resourceTypeId == "");
      if (b.length > 0) {
        this.$message.error("请为相应资源选择类别");
        return false;
      }
      let v = this.clickData;

      this.$ajax
        .post(
          "/server/resource/center/save",
          {
            sectionId: this.sectionId,
            subjectId: this.subjectId,
            versionId: this.clickData[0] ? this.clickData[0].id : "",
            dataId: this.clickData[1] ? this.clickData[1].dataId : "",
            volumeId: this.clickData[1] ? this.clickData[1].id : "",
            firstChapterId: this.clickData[2] ? this.clickData[2].id : "",
            secondChapterId: this.clickData[3] ? this.clickData[3].id : "",
            thirdChapterId: this.clickData[4] ? this.clickData[4].id : "",
            fourthChapterId: this.clickData[5] ? this.clickData[5].id : "",
            gradeId: this.form.gradeId,
            files: this.data,
            createUserId: this.userModule.userId,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.$alert("本次上传成功了" + this.data.length + "条资源", "上传成功", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.clickData = [];
              this.selData = "";
              this.form.gradeId = "";
              this.data = [];
              // let n = this.$refs.tree.store.root;
              // this.shrink(n);
            },
          });
        });
    },
    shrink(n) {
      n.expanded = false;
      if (n.childNodes && n.childNodes.length > 0) {
        n.childNodes.filter((el) => {
          this.shrink(el);
        });
      }
    },
    async uploadSectionFile(params) {
      await this.upload(params).then((file) => {
        this.data.push({
          fileName: file.name,
          fileUrl: file.url,
          fileSize: file.size,
          filePage: "",
          resourceTypeId: "",
          type: file.type,
          fileType: file.fileType,
          isShareSystem: true,
          isPrint: false,
          // printType: false,
          // printNumber: 0,
        });
      });
    },
    treeClick(d, n, a) {
      this.clickData = [];
      this.forTree(n);
    },
    forTree(n) {
      if (n.level != 0) {
        this.clickData.push(n.data);
        this.forTree(n.parent);
      }
    },
    selApd(section, subject) {
      this.treeShow = false;
      this.apd = section.label + subject.label;
      this.sectionId = section.id;
      this.subjectId = subject.id;
      this.treeShow = true;
      this.getGrade();
      this.clickData = [];
      this.selData = "";
      this.form.gradeId = "";
      // window.sessionStorage.setItem("breadcrumb", JSON.stringify(['资源中心',section.text+subject.text]));
      // window.sessionStorage.setItem(
      //   "currentDirectory",
      //   JSON.stringify({
      //         sectionId: section.node,
      //         sectionName: section.text,
      //         subjectId: subject.node,
      //         subjectName: subject.text,
      //       })
      // );
    },
    async loadNode(node, resolve) {
      let url;
      let a;
      if (node.level == 0) {
        url = "/common/catalog/load/version";
      } else {
        url =
          node.data.type == "version"
            ? "/common/catalog/load/volume"
            : node.data.type == "volume"
            ? "/common/catalog/load/chapter"
            : node.data.type == "chapter"
            ? "/common/catalog/load/chapter"
            : "";
      }
      a = await this.$ajax.post(url, {
        sectionId: this.sectionId,
        subjectId: this.subjectId,
        versionId: node.data ? node.data.versionId : "",
        chapterId: node.level == 2 ? "" : node.data ? node.data.node : "",
        dataId: node.data ? node.data.dataId : "",
      });
      a.map((el) => {
        el.childCount = el.childCount == 0;
      });
      return resolve(a);
    },
    getRelationDataId(n, v) {
      if (n.level == v) {
        return n.data.node;
      } else {
        return this.getRelationDataId(n.parent, v);
      }
    },
    getData() {
      this.$ajax.post("/common/load/resource/type").then((res) => {
        this.categoryData = res;
      });

      // this.$ajax
      //   .post("/common/catalog/load/chapter", {
      //     sectionId: this.breadcrumbData.section,
      //     subjectId: this.breadcrumbData.subject,
      //   })
      //   .then((res) => {
      //     this.relationData = res;
      //   });
    },
  },
};
</script>

<style>
.tree {
  position: relative;
  height: 300px;
  width: 1060px;
}
.tree div {
  position: absolute;
  top: 0;
  height: 100%;
  left: 180px;
}

.tree div:first-child {
  left: 0;
}
.tree ul {
  overflow: auto;
  width: 158px;
  height: 100%;
  margin-right: 5px;
  border: solid 1px #ddd;
  line-height: 30px;
}
.tree li {
  padding: 0 4px;
  width: 150px;
  overflow: hidden;
}

.tree li span {
  cursor: pointer;
  display: block;
  white-space: nowrap;
}

.tree li > div {
  display: none;
}
.tree li.on {
  background-color: #0096ff;
}
.tree li.on > span {
  color: #fff;
}

.tree li.on > div {
  display: block;
}
</style>

<style></style>



// WEBPACK FOOTER //
// src/page/resource/upload2.vue